import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, CanMatchFn, Route, RouterStateSnapshot, UrlSegment } from '@angular/router';
import { AuthenticationService } from './authentication.service';

export const canActivateAuthGuard: CanActivateFn = (_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) =>
	inject(AuthenticationService).isAuthenticated.getValue();

export const canMatchAuthGuard: CanMatchFn = (_route: Route, _segments: UrlSegment[]) =>
	inject(AuthenticationService).isAuthenticated.getValue();
